/**
 * Whether the text-box toolbar shows Apply role: the trigger and the role
 * popover, its admin authoring row included (that row is the one way into
 * `ThemeRoleDecorationModal`). Off: the role menu is not ready to ship, so
 * neither renders, for admins and everyone else alike. The
 * i18n keys, `pickRole`, the `'role'` menu name and the `onAuthorRole` /
 * `onPulseRoleTarget` plumbing stay wired, so on, the trigger and the
 * popover return with this one line. Its own module with no imports, so a
 * spec can read it without loading the toolbar.
 */
export const EDITOR_TEXT_BOX_ROLE_MENU_IN_TOOLBAR = false
